import { CircularProgress, Modal } from "@mui/material";

/** @deprecated We are phasing out `cc-ui` */
export interface LoadingIndicatorFullPageProps {
  open: boolean;
}

/** @deprecated We are phasing out `cc-ui` */
const LoadingIndicatorFullPage = ({ open }: LoadingIndicatorFullPageProps) => {
  return (
    <Modal
      disableAutoFocus
      hideBackdrop
      open={open}
      sx={{
        alignItems: "center",
        backgroundColor: "hsla(0,0%,100%,0.97)",
        display: "flex",
        justifyContent: "center",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <CircularProgress data-testid="spinner" />
    </Modal>
  );
};

/** @deprecated We are phasing out `cc-ui` */
export default LoadingIndicatorFullPage;
